<template>
    <div class="col-lg-4 col-md-6">
        <div class="product-section-wrapper" :class="{'product-section-wrapper--hovered': isHoveringOverProductImage}">

            <div class="product-section-wrapper__top-bar">
                <div class="product-section-wrapper__top-bar__place">
                    {{index}}
                </div>

                <a
                    v-if="!product.isStarred"
                    href
                    @click.prevent="starButtonClicked"
                    class="product-section-wrapper__top-bar__star">
                    (Star)
                </a>

                <a
                    v-if="product.isStarred"
                    href
                    @click.prevent="unstarButtonClicked"
                    class="product-section-wrapper__top-bar__star product-section-wrapper__top-bar__star--starred">
                    (Star Filled)
                </a>
            </div>

            <div class="product-section-wrapper__image-wrapper">
                <a
                    class="product-section-wrapper__image-wrapper__link"
                    :href="product.DetailPageURL"
                    target="_blank"
                    @mouseover="isHoveringOverProductImage = true"
                    @mouseout="isHoveringOverProductImage = false"
                >
                    <img
                        v-if="product.LargeImage"
                        class="product-section-wrapper__image-wrapper__link__image img-fluid"
                        :src="product.LargeImage.URL"
                        :alt="product.ItemAttributes.Title"
                    >
                    <span
                        v-if="!product.LargeImage"
                        class="product-section-wrapper__image-wrapper__link__image img-fluid"
                    >
                        (Image)
                    </span>
                </a>
            </div>

            <div class="product-section-wrapper__bottom-wrapper">
                <a
                    :href="product.DetailPageURL"
                    target="_blank"
                    class="product-section-wrapper__bottom-wrapper__title"
                    @mouseover="isHoveringOverProductImage = true"
                    @mouseout="isHoveringOverProductImage = false">
                    {{product.ItemAttributes.Title | truncate(100)}}
                </a>

                <div class="product-section-wrapper__bottom-wrapper__bottom-bar">
                    <div class="product-section-wrapper__bottom-wrapper__bottom-bar__price">
                        {{formatPrice(product.ItemAttributes.ListPrice.Amount)}}
                    </div>

                    <a href @click.prevent="$root.$emit('bv::show::modal','product-reviews-modal' + product.ASIN); $ga.event('click', 'click', 'Product Reviews')" class="product-section-wrapper__bottom-wrapper__bottom-bar__reviews">
                        (Megaphone)
                    </a>

                    <a href @click.prevent="$root.$emit('bv::show::modal','product-info-modal' + product.ASIN); $ga.event('click', 'click', 'Product Info')" class="product-section-wrapper__bottom-wrapper__bottom-bar__info">
                        (Info Circle)
                    </a>
                </div>
            </div>

        </div>

        <product-reviews-modal
            :product="product"
        ></product-reviews-modal>

        <product-info-modal
            :product="product"
        ></product-info-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import exchangeRatesData from '@/data/exchange-rates.json'

export default {
    name: 'product',
    props: {
        product: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        selectedCurrency: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            isHoveringOverProductImage: false,
            exchangeRates: exchangeRatesData
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
    },
    methods: {
        async starButtonClicked () {
            this.$ga.event('click', 'click', 'Starred')

            if (!this.user) {
                this.$toasted.info('You must be logged in to save your favorite products.')
                return
            }

            try {
                await this.$store.dispatch('products/starItem', {
                    asin: this.product.ASIN,
                    data: JSON.stringify(this.product)
                })
                this.$forceUpdate()
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server. Please try again.')
            }
        },
        async unstarButtonClicked () {
            this.$ga.event('click', 'click', 'Unstarred')

            if (!this.user) {
                this.$toasted.info('You must be logged in to save your favorite products.')
                return
            }

            try {
                await this.$store.dispatch('products/unstarItem', {
                    asin: this.product.ASIN,
                    data: JSON.stringify(this.product)
                })
                this.$forceUpdate()
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server. Please try again.')
            }
        },

        formatPrice (amount) {
            let formatted
            if (!this.exchangeRates[this.selectedCurrency.code]) {
                formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.selectedCurrency.code }).format(1 * (amount / 100))
            } else {
                formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.selectedCurrency.code }).format(this.exchangeRates[this.selectedCurrency.code] * (amount / 100))
            }

            return formatted
        }
    },
    async mounted () {
    },
    created () {
    },
    watch: {
    },
    validations: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';

    .product-section-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        height: auto;
        min-height: 500px;
        width: 100%;
        -ms-overflow-style: none;
        overflow: hidden;
        background: $white;
        border-radius: 4px;
        border: $border;
        box-shadow: $heavy-box-shadow;
        margin-bottom: 30px;

        &--hovered {
            box-shadow: 0 4px 16px 0 rgba($grey, 0.6);
        }

        &__top-bar {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 5px 10px;

            &__place {
                margin: 10px auto auto 10px;
                font-weight: bold;
                color: $white;
                background: $purple;
                border-radius: 50%;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: $light-box-shadow;
            }

            &__star {
                margin: 10px 10px auto auto;
                border-radius: 50%;
                box-shadow: $light-box-shadow;
                font-size: 1.2rem;

                &--deselected {
                    color: $grey;

                    &:hover {
                        color: $black;
                    }
                }

                &--selected {
                    color: $yellow;

                    &:hover {
                        color: $dark-yellow;
                    }
                }

                &--starred {
                    color: $purple;

                    &:hover {
                        color: $dark-purple;
                    }
                }
            }
        }

        &__image-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-top: auto;
            margin-bottom: auto;

            &__link {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: auto;

                &:hover {
                    opacity: 0.85;
                }

                &__image {
                    max-height: 200px;
                    margin-bottom: auto;
                    color: $purple;
                }
            }
        }

        &__bottom-wrapper {
            background: $purple;

            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            &__title {
                color: $white;
                margin-bottom: 10px;
                font-weight: bold;
                padding: 15px;

                &:hover {
                    text-decoration: none;
                    color: $yellow;
                }
            }

            &__bottom-bar {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                margin-top: auto;
                padding: 5px 10px;
                background: darken($purple, 5%);

                &__price {
                    color: $white;
                    font-weight: bold;
                }

                &__reviews {
                    margin-left: auto;
                    margin-right: 10px;

                    svg {
                        font-size: 1.2rem;
                        color: $yellow;
                    }
                }

                &__info {
                    svg {
                        font-size: 1.2rem;
                        color: $yellow;
                    }
                }
            }
        }
    }
</style>
